import React, { memo } from 'react';
const bonuses = [{
  title: 'BONUS 1 — EMERGENTES ESI',
  tagline: '12 actividades listas para trabajar situaciones reales del aula.',
  image: 'https://cdn.magicpatterns.com/uploads/eQC6U526XxQxnJBRV8f1xh/bonus_1.png',
  alt: 'Emergentes ESI',
  bullets: ['Burlas entre compañeros', 'Exclusión', 'Conflictos', 'Rumores', 'Respeto', 'Convivencia']
}, {
  title: 'BONUS 2 — ACTIVIDADES EXPRESS ESI',
  tagline: '48 propuestas rápidas para usar en pocos minutos.',
  image: 'https://cdn.magicpatterns.com/uploads/4G8XSPDKCGvMw6QnPBQJ8F/bonus_2.png',
  alt: 'Actividades Express ESI',
  bullets: ['Emociones', 'Autoestima', 'Amistad', 'Respeto', 'Diversidad', 'Convivencia']
}, {
  title: 'BONUS 3 — AFICHES ESI PARA EL AULA',
  tagline: '12 afiches visuales listos para colocar en el aula.',
  image: 'https://cdn.magicpatterns.com/uploads/9KL9Jw3wufpaedwGNhhAmb/bonus_3.png',
  alt: 'Afiches ESI para el Aula',
  bullets: ['Emociones', 'Buen trato', 'Convivencia', 'Diversidad', 'Derechos', 'Ciudadanía digital']
}, {
  title: 'BONUS 4 — CIUDADANÍA DIGITAL PARA PRIMARIA',
  tagline: '12 actividades listas para imprimir.',
  image: 'https://cdn.magicpatterns.com/uploads/89wGLkxNRoUUkXLrfKU3es/bonus_4.png',
  alt: 'Ciudadanía Digital para Primaria',
  bullets: ['Privacidad', 'Contraseñas', 'Ciberbullying', 'Huella digital', 'Noticias falsas', 'Uso responsable de internet']
}];
export function BonusSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-32" data-mp="25r10ipz5yz5i">
      <div className="max-w-5xl mx-auto" data-id="element-33" data-mp="25rsxa44hz2xd">
        <div className="text-center mb-8" data-id="element-34" data-mp="3c6tt89tivl3y">
          <h2 className="text-[20px] font-black mb-3 text-[#EF5B4C]" data-id="element-35" data-mp="3c61yf17r1req">
            Además recibís 4 bonus exclusivos
          </h2>
          <div className="inline-block bg-red-600 text-white text-base md:text-lg font-black px-6 py-2 rounded-full shadow-lg animate-bounce" data-id="element-36" data-mp="3h7hjgt9xfxx4">
            🎁 GRATIS POR HOY
          </div>
        </div>

        <div className="space-y-8" data-id="element-37" data-mp="1c6ojmu5a1zgj">
          {bonuses.map((b, i) => <div key={i} className={`flex flex-col ${i % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-6 bg-gray-50 rounded-3xl p-6 border border-gray-200`} data-id="element-38" data-mp="1q3ahw6921qbh" data-mpi={i}>
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-39" data-mp="yajgzigffdfw">
                <img src={b.image} alt={b.alt} className="w-[340px] h-[340px] object-contain drop-shadow-xl" data-id="element-40" data-mp="tfdx0p6l48ug" />
              </div>
              <div className="w-full md:w-1/2" data-id="element-41" data-mp="12cy1s83non9t">
                <h3 className="text-2xl md:text-3xl font-black mb-2 text-[#2E2A6B]" data-id="element-42" data-mp="eoojhg5nihnf">
                  🎁 {b.title}
                </h3>
                <p className="text-lg text-gray-700 mb-4" data-id="element-43" data-mp="amjs6o2odx3y">{b.tagline}</p>
                <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-base text-gray-800" data-id="element-44" data-mp="iux0ah98tbn">
                  {b.bullets.map((item, idx) => <li key={idx} className="flex items-center" data-id="element-45" data-mp="5bfpn8ofd0dl" data-mpi={idx}>
                      <span className="text-green-600 mr-2 font-bold" data-id="element-46" data-mp="3mre4z99vw1x7">✔</span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}